import React, { useCallback } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { isVisible } from '@atlas/core';
import { Outcome, SettledOutcome } from '@atlas/ui';

import { sportService } from 'common/constants';
import eventShape from 'common/PropTypes/eventShape';
import marketShape from 'common/PropTypes/marketShape';
import marketTypeShape from 'common/PropTypes/marketTypeShape';
import outcomeShape from 'common/PropTypes/outcomeShape';

const SimpleOutcomeColumn = props => {
  const {
    className,
    customName,
    disabled = false,
    event,
    isFake,
    market,
    marketType: { betGroups, id: marketTypeId },
    name,
    outcome,
    outcome: { odds, settlementStatus, status },
    suspended,
  } = props;
  const outcomeName = customName || name;
  const visible = disabled || isVisible(event) || isVisible(market) || isVisible(outcome);

  const clickHandler = useCallback(
    event => {
      event.marketTypeId = marketTypeId;
      event.betGroups = betGroups;
      event.marketId = market.id;
    },
    [market.id, marketTypeId, betGroups],
  );

  if (event.sportService !== sportService.ARCHIVED && !visible) {
    return null;
  }

  if (event.sportService === sportService.ARCHIVED) {
    const settledOutcomeClass = settlementStatus && settlementStatus.toLowerCase();
    const settledOutcomeClassName = cx(className, { [settledOutcomeClass]: settledOutcomeClass });

    if (!isFake) {
      return (
        <SettledOutcome
          className={settledOutcomeClassName}
          key={outcome.id}
          name={outcomeName}
          settlementStatus={settlementStatus}
        />
      );
    }
  }

  return (
    <>
      {isFake && <span className="outcome-fake">-</span>}
      <Outcome
        className={className}
        id={outcome.id}
        key={outcome.id}
        name={outcomeName}
        odds={odds}
        onClick={clickHandler}
        outcome={outcome}
        status={status}
        suspended={suspended}
      />
    </>
  );
};

SimpleOutcomeColumn.propTypes = {
  customName: PropTypes.string,
  disabled: PropTypes.bool,
  event: eventShape.isRequired,
  market: marketShape.isRequired,
  marketType: marketTypeShape.isRequired,
  name: PropTypes.string,
  outcome: outcomeShape.isRequired,
  suspended: PropTypes.bool,
};

export default SimpleOutcomeColumn;
